import { useState } from 'react';
import Hero from './components/Hero';
import Technology from './components/Technology';
import About from './components/About';
import UserVoice from './components/UserVoice';
import Steps from './components/Steps';
import FAQ from './components/FAQ';
import News from './components/News';
import Contact from './components/Contact';
import Header from './components/Header';
import Footer from './components/Footer';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <main>
        <Hero />
        <Technology />
        <About />
        <UserVoice />
        <Steps />
        <FAQ />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
